import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info-outline--sprite",
  "use": "info-outline--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"info-outline--sprite\">\n<path d=\"M6.325 9.025H7.675V10.375H6.325V9.025ZM6.325 3.625H7.675V7.675H6.325V3.625ZM6.99325 0.25C3.26725 0.25 0.25 3.274 0.25 7C0.25 10.726 3.26725 13.75 6.99325 13.75C10.726 13.75 13.75 10.726 13.75 7C13.75 3.274 10.726 0.25 6.99325 0.25ZM7 12.4C4.0165 12.4 1.6 9.9835 1.6 7C1.6 4.0165 4.0165 1.6 7 1.6C9.9835 1.6 12.4 4.0165 12.4 7C12.4 9.9835 9.9835 12.4 7 12.4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol